export type AccessStatus = "allowed" | "login_required" | "membership_required" | "reauthentication_required" | "unavailable" | "backend_unavailable";

export interface AccessSession {
  authenticated: boolean;
  accessStatus: AccessStatus;
  verification?: "live" | "grace";
  graceExpiresAt?: number;
  user?: { id: string; username: string; globalName: string | null; avatar: string | null };
}

export async function verifyDiscordAccess() {
  try {
    const response = await fetch("/api/auth/me", { credentials: "same-origin", cache: "no-store" });
    const body = await response.json().catch(() => null) as AccessSession | null;
    if (body?.accessStatus) return body;
    return { authenticated: false, accessStatus: "backend_unavailable" } satisfies AccessSession;
  } catch {
    return { authenticated: false, accessStatus: "backend_unavailable" } satisfies AccessSession;
  }
}
